module.exports = __webpack_public_path__ + "media/images/parallax/illustration-welcome-middleground-c0342eb473a3f52e1d397d2e866146aa.svg";